var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,_vm._g(_vm._b({ref:"input",tag:"component"},'component',_vm.bindings,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }